import api from "@/api/customAxios";

export default {
    // 로그인
    postLogin(param) {
        return api.post('/api/auth/login', param)
    },
    // 유저 정보 호출
    postUserInfo(param) {
        return api.post('/api/auth/userInfo')
    },

    // 비밀번호 재설정 > 인증번호 보내기
    postVerifyEmailSend(param) {
        return api.post('/api/auth/verifyEmailSend', param)
    },

    // 비밀번호 재설정 > 인증번호 확인
    postEmailVerify(param) {
        return api.post('/api/auth/emailVerify', param)
    },

    // 비밀번호 재설정 > 비밀번호 재설정
    postPasswordReset(param) {
        return api.post('/api/auth/passwordReset', param)
    },

    // 스케줄 > 일별 리스트데이터 조회
    postGetAnnualListInDt(param) {
        return api.post('/api/annual/getAnnualListInDt', param)
    },

    // 스케줄 > 월별 리스트데이터 조회
    postGetAnnualListInMonthly(param) {
        return api.post('/api/annual/getAnnualListInMonthly', param)
    },

    // 스케줄 > 월별 달력리스트 조회
    postGetAnnualCal(param) {
        return api.post('/api/annual/getAnnualCal', param)
    },

    // 스케줄 > 리스트 > 휴가취소
    postDelAnnual(param) {
        return api.post('/api/annual/delAnnual', param)
    },

    // 휴가 결재 대기 리스트
    postAnnualAprvlWaitlList(param) {
        return api.post('/api/annual/getAnnualAprvlWaitlList', param)
    },

    // 휴가 결재 리스트
    postAnnualAprvlList(param) {
        return api.post('/api/annual/getAnnualAprvlList', param)
    },

    // 휴가 결재 승인
    postApprovalAnnual(param) {
        return api.post('/api/annual/approvalAnnual', param)
    },

    // 휴가 결재 반려
    postRejectAnnual(param) {
        return api.post('/api/annual/rejectAnnual', param)
    },

    postGetAllList(param) {
        return api.post('/api/mng/getAllList', param)
    },

    postGetUsrInfListAll() {
        return api.post('/api/usr/getUsrInfListAll')
    },

    postGetCntList(param) {
        return api.post('/api/mng/getCntList', param)
    },

    postGetUseList(param) {
        return api.post('/api/mng/getUseList', param)
    },

    postUsrInsert(param) {
        return api.post('/api/usr/insert', param)
    },

    // 휴가등록 > 공통코드
    postGetComCdList(param) {
        return api.post('/api/common/getComCdList', param)
    },

    // 휴가등록 > 휴가별 휴가일수
    postGetAnnualInfListByAnnualCd(param) {
        return api.post('/api/annual/getAnnualInfListByAnnualCd', param)
    },

    // 휴가등록 > 결재자목록
    postGetUsrInfList(param) {
        return api.post('/api/usr/getUsrInfList', param)
    },

    // 휴가등록 > 휴가등록
    postInsAnnual(param) {
        return api.post('/api/annual/insAnnual', param)
    },

    postInsAnnualInf(param) {
        return api.post('/api/annual/insAnnualInf', param)
    },

    // 휴가 결재 > 결재자 변경
    postChngAnnualApprovalId(param) {
        return api.post('/api/annual/chngAnnualApprovalId', param)
    },

    // 휴가 결재 > 휴가기간 > 달력의 휴무일 리스트
    postGetHolidayCal(param) {
        return api.post('/api/annual/getHolidayCal', param)
    },


}
